// utils/ProtectedRoutes.js
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const ProtectedRoutes = ({ children, allowedRoles }) => {
  const { role, userLoading } = useSelector(
    (state) => state.userAuthReducer
  );

  const token = localStorage.getItem("token");

  // Handle loading state
  if (userLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status"></div>
      </div>
    );
  }

  // Handle authentication
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Handle authorization
  if (!allowedRoles.includes(role) && role !== null) {
    return <Navigate to="/immobilier" replace />;
  }

  return children;
};

export default ProtectedRoutes;
